import { AppInfosAction, AppInfosActionKeys } from './actions';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';

export enum AppType {
	Multiple = 'multiple',
	Single = 'Single'
}

const initialState = {
	areCookieAccepted: !UserAgentUtils.isMobileApp && Utils.getCookie('areCookieAccepted')
} as AppInfosState;

export interface AppInfosState {
	areCookieAccepted: boolean;
	type?: AppType;
	userLocale?: string;
}

export function appInfos(
	state: AppInfosState = initialState,
	action: AppInfosAction
): AppInfosState {
	switch (action.type) {
		case AppInfosActionKeys.ACCEPT_COOKIE:
			return { ...state, areCookieAccepted: true };
		case AppInfosActionKeys.SET_APP_TYPE:
			return { ...state, type: action.appType };
		case AppInfosActionKeys.SET_USER_LOCALE:
			return { ...state, userLocale: action.locale };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/reducer.ts